import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class App extends Component {
  render() {
      return <div className="App">
          <div className="App-header">
              <img onClick={() => alert("oyeah!")} src={logo} className="App-logo" alt="logo"/>
              <h1>Welcome to another web Pokedex</h1>
          </div>
          <div>
          <h2>Because why not?</h2>
              <p>Lorem ipsum dolor sit amet, noluisse nominati cotidieque in nam. In usu purto blandit contentiones, ex quando alienum vis, eos recteque torquatos reprimique eu. Meis tamquam in mel, cu sit dicunt sententiae. Meis vitae neglegentur his an, ei usu mollis convenire. Id sea option molestie, et tempor scaevola senserit duo. Enim erat illum id est. An eos vidit ludus.
              </p>
              <p>Utroque reprehendunt ut his, justo errem labitur eu nec. Id vel quaeque sensibus aliquando, everti intellegat vis at. Quot altera persecuti ius ad, eu vel causae regione. Aperiam impedit adversarium mei ad, in his ornatus ponderum appellantur, primis sensibus mea et. Ea oratio expetendis sed, sit cu quod adipiscing.
              </p>
              <p>Quo tibique omnesque dignissim te, qui agam ipsum cu. Te errem semper eum, novum legere primis at vim. Probo melius ad vis, has ea scripta feugait iudicabit. Wisi atomorum vulputate te vel. In ignota eirmod lucilius qui, pri facete audiam vocibus at, quo laboramus elaboraret in.
              </p>
              <p>Ad nostro possim tacimates sea. Illum partem nominavi ei pro, ius in duis nostro. Te admodum ceteros conclusionemque sed, illud abhorreant inciderint in usu. Eius melius audire sea te, te pri legere ridens temporibus. Cu solum disputando deterruisset per, mel te autem molestie intellegebat, sea ne veri graeci dissentiet. Te prima utamur duo, quo stet commodo malorum ad.
              </p>
              <p> Sit dicunt suscipit consequat ut. Veri audiam pericula pro te, prima dicant maiorum id eos, in vel simul tollit animal. Inani primis indoctum ei has, no debitis omnesque neglegentur cum, purto adhuc ius in. Vis id ridens mediocrem, nam odio deseruisse te. Sonet repudiare qui at. Per graeco habemus ei, commodo inciderint eum in, nam dicit commune appareat et.
              </p>
          </div>
      </div>;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js